import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/duties/working-time-booking")({
  component: Outlet,
  beforeLoad: ({ context }) => ({
    getTitle: () => context.t?.("NavItem_WorkingTimeBooking"),
  }),
})
